<main class="main">
  <router-outlet />
</main>